"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.reportAccessibility = exports.usePageLoadMetrics = void 0;
const graphene_1 = __importDefault(require("@snapchat/graphene"));
const react_1 = require("react");
const web_vitals_1 = require("web-vitals");
const performanceTiming_1 = require("./lib/performanceTiming");
/**
 * React hook to incorporate performance metrics into a React page.
 *
 * @param pageId Custom id of the page we're sending metrics for. Ex - LENS_HOME_PAGE
 * @param metricsPrefix Custom prefix to specify which domain we're collecting
 * metrics for. Ex - WebStories, WebLenses
 */
function usePageLoadMetrics(pageId, metricsPrefix) {
    const webVitalsContainer = (0, react_1.useRef)({});
    (0, react_1.useEffect)(() => {
        if (!graphene_1.default.isReady() && process.env.NODE_ENV !== "production") {
            console.error("Graphene not initialized");
        }
        sendWebVitalsMetrics(pageId, webVitalsContainer);
        (0, performanceTiming_1.supplementWebVitals)(pageId, metricsPrefix);
    });
    return webVitalsContainer;
}
exports.usePageLoadMetrics = usePageLoadMetrics;
function sendWebVitalsMetrics(pageId, webVitalsContainer) {
    function collectMetricsAndReportToGraphene(metric) {
        webVitalsContainer.current[metric.name] = metric.value;
        reportToGraphene(metric, pageId);
    }
    (0, web_vitals_1.getCLS)(collectMetricsAndReportToGraphene);
    (0, web_vitals_1.getFID)(collectMetricsAndReportToGraphene);
    (0, web_vitals_1.getFCP)(collectMetricsAndReportToGraphene);
    (0, web_vitals_1.getLCP)(collectMetricsAndReportToGraphene);
    (0, web_vitals_1.getTTFB)(collectMetricsAndReportToGraphene);
}
function reportToGraphene(metric, pageId) {
    const metricName = metric.name;
    const metricVal = Math.round(metric.value);
    graphene_1.default.addTimer({
        metricsName: "page_load_" + metricName,
        milliSec: metricVal,
        dimensions: { pageId },
    });
}
var reportAccessibility_1 = require("./lib/a11y/reportAccessibility");
Object.defineProperty(exports, "reportAccessibility", { enumerable: true, get: function () { return reportAccessibility_1.reportAccessibility; } });
//# sourceMappingURL=index.js.map